module.exports = __webpack_public_path__ + "img/Jstars.0a4c0715.jpg";